import React from 'react';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const faqs = [
  {
    question: "Hvilken pre-workout i Norge har høyest dosering?",
    answer: "Peveo Competition PWO Stim-Free har Norges høyeste doser av nøkkelingredienser: 10 000 mg ren L-Citrulline, 5 000 mg Betaine, 3 000 mg L-Tyrosine og 3 000 mg Taurine per porsjon. Til sammenligning inneholder gjennomsnittet av kommersielle PWO-produkter kun 3 500 mg L-Citrulline ifølge Sperlich et al. (2019). Peveo leverer nesten 3 ganger markedsstandard."
  },
  {
    question: "Hva er den sterkeste stimulant-frie PWO-en i Norge?",
    answer: "Peveo Competition PWO er Norges sterkeste stimulant-frie pre-workout, med en total porsjonsstørrelse på 31 gram rene aktive ingredienser. Produktet er bevisst koffeinfritt fordi koffein kan påvirke søvnkvalitet negativt – og god søvn er avgjørende for muskelrestitusjon og treningsresultater."
  },
  {
    question: "Hvilken PWO har mest L-Citrulline?",
    answer: "Peveo Competition PWO inneholder 10 000 mg ren L-Citrulline per porsjon – den fysiologiske maksdosen ifølge Moinard et al. (2008). De fleste konkurrenter bruker kun 3 000–6 000 mg, ofte som Citrulline Malate som gir enda lavere effektiv dose. Peveo bruker 100 % ren L-Citrulline for maksimal effekt."
  },
  {
    question: "Er Peveo Competition PWO verdt prisen?",
    answer: "Ja. Til 299 kr får du 31 gram aktive ingredienser per porsjon, alle dosert på eller over klinisk effektive nivåer. Mange konkurrenter koster det samme men inneholder bare 5–10 gram aktive ingredienser, ofte skjult i «proprietary blends». Ifølge Jagim et al. (2019) er 44,3 % av ingredienser i toppselgende PWO-er skjult uten oppgitt mengde. Peveo oppgir alt."
  },
  {
    question: "Hvorfor har ikke Peveo PWO koffein?",
    answer: "Peveo har bevisst valgt bort koffein. Koffein er ofte den eneste korrekt doserte ingrediensen i konkurrentenes PWO, men det er også den eneste som kan gi negative effekter over tid ved å redusere søvnkvaliteten. Peveo fokuserer i stedet på aminosyrer med dokumentert effekt på blodgjennomstrømning, utholdenhet og kognisjon – uten å påvirke søvnen din."
  }
];

const PwoFaqSection = () => {
  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": faqs.map(faq => ({
      "@type": "Question",
      "name": faq.question,
      "acceptedAnswer": {
        "@type": "Answer",
        "text": faq.answer
      }
    }))
  };

  return (
    <section className="mt-16 border-t border-border pt-12">
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }}
      />
      <h2 className="text-3xl font-bold text-primary text-center mb-8 font-orbit">
        Vanlige spørsmål om Peveo PWO
      </h2>
      <div className="max-w-3xl mx-auto">
        <Accordion type="single" collapsible className="w-full">
          {faqs.map((faq, index) => (
            <AccordionItem key={index} value={`faq-${index}`} className="border-border">
              <AccordionTrigger className="text-left text-primary hover:text-primary/80 hover:no-underline text-base sm:text-lg">
                {faq.question}
              </AccordionTrigger>
              <AccordionContent className="text-muted-foreground text-sm sm:text-base leading-relaxed">
                {faq.answer}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
};

export default PwoFaqSection;
